import React from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import HeaderSection from './Header/HeaderSection';
import AlertBanner from '../components/Banner/AlertBanner';

const Layout = ({ loading }) => {
  return (
    <>
      {!loading && (
        <>
          <HeaderSection />
          <AlertBanner />
        </>
      )}
      <Outlet />
    </>
  );
};

Layout.propTypes = {
  loading: PropTypes.bool
};

export default Layout;
